// extracted by mini-css-extract-plugin
export var columnList = "_dh-0";